import React from 'react'
import Carousel from '../Carousel'
import ConverseValues from './Values'
import Team from './Team'
import ServeYouth from './ServeYouth'
import SparkProgress from './SparkProgress'
import DareGreatly from './DareGreatly'
import DoTheRightThing from './DoTheRightThing'
import WinTogether from './WinTogether'
import Maxims from '../../../images/converseValues/_FA_22_KIDS_LOP_DA_KYLIE_DBG_0245 3.png'

const ConverseValuesPage = (props) => {
	const converseList = [<ServeYouth />, <SparkProgress />, <DareGreatly />, <DoTheRightThing />, <WinTogether />]
	return (
		<div className={props.status ? 'hide' : 'show'}>
			<ConverseValues />
			<Team />

			<div className='converseValues-wrapper'>
				<Carousel list={converseList} scrollPos={1470} />
			</div>
		</div>
	)
}

export default ConverseValuesPage



// WEBPACK FOOTER //
// ./src/containers/AboutPage/ConverseValues/index.js